import Big from 'big.js';

/**
 * 计算未接盈亏
 */
export function calcUnrealisedPnlEv({
  side,
  contractSide,
  contractSize,
  qty,
  entryPriceEp,
  exitPriceEp,
  factor,
  priceFactor,
}) {
  if (qty === 0 || entryPriceEp === 0 || exitPriceEp === 0) {
    return 0;
  }
  const entryValueEv = calcValueEv(contractSide, contractSize, priceFactor, factor, qty, entryPriceEp);
  const exitValueEv = calcValueEv(contractSide, contractSize, priceFactor, factor, qty, exitPriceEp);
  if (side === 'Buy') {
    return (exitValueEv - entryValueEv) * contractSide;
  }

  if (side === 'Sell') {
    return (entryValueEv - exitValueEv) * contractSide;
  }

  return 0;
}

export function calcValueEv(contractSide, contractSize, priceFactor, valueFactor, quantity, priceEp) {
  return Number(calcValueBig(contractSide, contractSize, priceFactor, quantity, priceEp).times(valueFactor));
}

export function calcValueRv(contractSide, contractSize, priceFactor, quantity, priceEp) {
  return calcValueBig(contractSide, contractSize, priceFactor, quantity, priceEp);
}

export function calcValue(contractSide, contractSize, priceFactor, valuePrecision, quantity, priceEp) {
  const valueBig = calcValueBig(contractSide, contractSize, priceFactor, quantity, priceEp);
  return valueBig.round(valuePrecision, 0).toFixed(valuePrecision);
}

export function calcValueBig(contractSide, contractSize, priceFactor, quantity, priceEp) {
  //TODO
  if (isNaN(quantity) || quantity === 0 || isNaN(priceEp) || priceEp === 0) {
    return Big(0);
  }
  const tmpBig = Big(quantity).times(contractSize);
  if (contractSide > 0) {
    return tmpBig.times(priceEp).div(priceFactor);
  }
  if (contractSide < 0) {
    return tmpBig.times(priceFactor).div(priceEp);
  }
  return Big(0);
}

export function calcMaxOrderQtyEvByValue(contract, closeEp) {
  if (closeEp <= 0) {
    return Number.MAX_SAFE_INTEGER;
  }
  const {contractSide, contractSize, priceFactor, maxOrderQty, qtyFactor} = contract;
  return Number(calcValueBig(contractSide, contractSize, priceFactor, maxOrderQty, closeEp).times(qtyFactor));
}

export function calcMaxOrderQtyEvByCoin(contract) {
  const {maxOrderQty, contractSize, qtyFactor} = contract;
  return Number(Big(maxOrderQty).times(contractSize).times(qtyFactor));
}
